import { useEffect, useState } from 'react';
import BluetoothTable from './BluetoothTable';
import { Button } from 'antd';
import AddBluetooth from './AddBluetooth';
import { useSDK } from '../../../../../../Hooks/TT_ELD/Mobile/SDK/index';

const BluetoothActivate = ({ activeTab }: { activeTab: string }) => {
  const [skip, setSkip] = useState<number>(1);
  const [status, setStatus] = useState<boolean>(true);

  const { data, isLoading, refetch, isFetching } = useSDK('BLE', {
    page: skip,
    perPage: '10',
    is_active: status,
  });

  useEffect(() => {
    if (activeTab === '1') {
      refetch();
    }
  }, [activeTab]);

  const onChange = (query: any) => {
    setSkip(query.current);
  };
  const showModal = () => {
    setOpen(true);
  };

  const [open, setOpen] = useState(false);
  return (
    <div className="mainPage">
      <span style={{ display: 'flex' }}>
        {open && <AddBluetooth open={open} setOpen={setOpen} dataRefetch={refetch} />}
        <Button type="primary" style={{ marginLeft: 'auto' }} size={'large'} onClick={showModal}>
          Add
        </Button>
        <Button style={{ marginLeft: 20 }} size={'large'} onClick={() => refetch()}>
          Refresh
        </Button>
      </span>
      <BluetoothTable
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
        skip={skip}
        status={status}
      />
    </div>
  );
};

export default BluetoothActivate;
